import {memo} from 'react'
import type {PreloadedQuery} from 'react-relay'

import type {AgentsPagesAgentTypesQuery} from '../../../__generated__/AgentsPagesAgentTypesQuery.graphql'
import {AgentPagePoolsSubscriber} from '../../../AgentPagePoolsProvider'
import {useAgentPoolFavoriteList} from '../../hooks/useAgentPoolFavorite'

import AgentPoolsFavoriteList from './AgentPoolsFavoriteList'

type Props = {
  searchQuery?: string
  agentTypesQueryRef: PreloadedQuery<AgentsPagesAgentTypesQuery>
}

function AgentPoolsFavoriteListContainer(props: Props) {
  const {searchQuery, agentTypesQueryRef} = props
  const favoritePools = useAgentPoolFavoriteList()

  return (
    <AgentPagePoolsSubscriber agentTypesQueryRef={agentTypesQueryRef}>
      <AgentPoolsFavoriteList favoritePools={favoritePools} searchQuery={searchQuery} />
    </AgentPagePoolsSubscriber>
  )
}

export default memo(AgentPoolsFavoriteListContainer)
